import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { TEU_LOGO_SVG } from '../../assets/constants';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css'
})
export class HeaderComponent {
  @Input() circleNumber: number = 1; // Número del círculo
  @Output() backClick = new EventEmitter<void>(); // Evento para el botón de atrás
  
  teuLogo: SafeHtml;

  constructor(private sanitizer: DomSanitizer) {
    this.teuLogo = this.sanitizer.bypassSecurityTrustHtml(TEU_LOGO_SVG);
  }

  goBack() {
    this.backClick.emit();
  }
}
